<template>
  <div class="ma-4">
    <add-mileage-dialog
      ref="transaction"
      :currentBalance="mileage.Amount"
    />
    <StaffNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <mileage-side
          :amount="mileage.Amount"
          :date="mileage.DatePeriod"
          :closeOut="CloseOut"
        />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-row dense>
          <v-col cols="12" md="12">
            <v-card elevation="0" outlined>
              <v-data-table
                :headers="headers"
                sort-asc
                :items="mileages"
                :item-class="rowColor"
                :loading="isLoading"
                loading-text="Loading Mileage"
                height="475"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-spacer></v-spacer>

                    <v-btn
                      :color="!CloseOut ? '#2b3990' : 'red'"
                      dark
                      class="mb-2 mt-2"
                      @click="!CloseOut ? showAdd() : ''"
                    >
                      <v-icon v-if="!CloseOut" left>add</v-icon>
                      {{ CloseOut ? "Close Out" : "New Mileage" }}</v-btn
                    >
                  </v-toolbar>
                </template>
                <!-- <template v-slot:item.ClientSignature="{ item }">
                  <v-img
                    max-height="80"
                    max-width="150"
                    :src="item.ClientSignature"
                  ></v-img>
                </template> -->
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="viewMileage(item)">
                    mdi-eye
                  </v-icon>
                  <v-icon
                    small
                    @click="
                      deleteMileage(item);
                      $event.stopPropagation();
                    "
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <template v-slot:no-data>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getMileages()"
                    >Reset</v-btn
                  >
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
/*eslint-disable */
import StaffNav from "@/components/StaffNav";
import Foot from "@/components/Footer";
import AddMileageDialog from "@/components/mileage/AddMileageDialog";
import MileageSide from "@/components/mileage/MileageSide";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    StaffNav,
    AddMileageDialog,
    MileageSide,
    Foot,
  },
  data() {
    return {
      dialog: true,
      show: null,
      search: "",
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Starting", value: "Starting" },
        { text: "Ending", value: "Ending" },
        { text: "Total", value: "Total" },
        { text: "($)Amount", value: "Amount" },
        { text: "($)Balance", value: "Balance" },
        { text: "Staff Signature", value: "StaffSignature" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: false,
      selection: 1,
      datePeriod: "",
      currentBalance: 0,
    };
  },

  created() {
    if (this.CloseOut === null) {
      this.$router.push({ name: "Mileage" });
    }
    this.getMileageTransactions(this.$route.params.mileageID);
  },

  computed: {
    ...mapState({
      mileages: (state) => state.mileages.mileageTransactions,
      CloseOut: (state) => state.mileages.CloseOut,
      Amount: (state) => state.mileages.mileages,
    }),

    ...mapGetters(["isLoading"]),

    mileage() {
      this.currentBalance = this.Amount.find(
        (item) => item._id === this.$route.params.mileageID
      );

      const mileageDate = this.mileages.map((item) => new Date(item.Date));

      return {
        Amount: this.currentBalance?.Amount,
        DatePeriod: mileageDate,
      };
    },
  },

  methods: {
    ...mapActions(["getMileageTransactions"]),

    ...mapMutations({
      setNewMileages: "SET_NEW_MILEAGES",
    }),

    showAdd() {
      this.setNewMileages(true);
    },

    viewMileage(item) {
      this.$refs.transaction.onViewItem(item);
      this.setNewMileages(true);
    },

    deleteMileage(item) {
      let confirmDeletion = confirm(
        "Are you sure you want to delete this mileage entry?"
      );
      if (confirmDeletion) {
        this.$store.dispatch("deleteMileageTransaction", item._id);
      }
    },

    rowColor(item) {
      return item.TransactionType == "Deposit" ? "Green" : "Red";
    },
  },
};
</script>
